import OrbitAvatar from '@/components/OrbitAvatar'
import { CaretDownFilled, CaretRightFilled } from '@ant-design/icons'
import { Space } from 'antd'
import classnames from 'classnames'
import dayjs from 'dayjs'
import React from 'react'
import styles from './index.module.less'

export const TaskListTable: React.FC<{
  rowHeight: number
  rowWidth: string
  fontFamily: string
  fontSize: string
  locale: string
  tasks: any[]
  selectedTaskId: string
  setSelectedTask: (taskId: string) => void
  onExpanderClick: (task) => void
}> = ({ rowHeight, tasks, onExpanderClick }) => {
  const assignMember = (task) => {
    const member = task.assignees?.[0]
    if (!member) {
      return null
    }
    return (
      <Space>
        <OrbitAvatar size={24} avatar={member.avatar} name={member.fullName} />
        {member.fullName}
      </Space>
    )
  }

  return (
    <div className={styles.taskListWrapper}>
      {tasks.map((t) => {
        let expanderSymbol: any = null
        if (t.hideChildren === false) {
          expanderSymbol = <CaretDownFilled />
        } else if (t.hideChildren === true) {
          expanderSymbol = <CaretRightFilled />
        }

        return (
          <div className={styles.taskListTableRow} style={{ height: rowHeight }} key={`${t.id}row`}>
            <div className={classnames(styles.taskListCell, styles.name)} title={t.name}>
              <div className={classnames(styles.taskListNameWrapper, styles[`nameLevel-${t.path?.length}`])}>
                <div className={styles.taskListExpander} onClick={() => onExpanderClick(t)}>
                  {expanderSymbol}
                </div>
                <div>{t.name}</div>
              </div>
            </div>

            <div className={styles.taskListCell}>{t.start && dayjs(t.start).format('YYYY-MM-DD')}</div>

            <div className={styles.taskListCell}>{t.end && dayjs(t.end).format('YYYY-MM-DD')}</div>

            <div className={styles.taskListCell}>{assignMember(t)}</div>
          </div>
        )
      })}
    </div>
  )
}
